import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useState, useEffect } from "react";
import { PaginationProps } from "antd/es/pagination";
import { IStockCheckFields, IDetailList, IStockCheckDetail, IStockCheckSearch, Detailed } from "./stockCheckType"
import { stockCheckService } from "./stockCheckService";
import { convertRes2Blob } from "@/utils/exportFile";

import {
    DEFAULT_FIRST_PAGE_NUM,
    DEFAULT_PAGE_SIZE,
    defaultMdCmParam
} from "@/utils/constants";
// import {
//     stockCheckService,
//     IStockCheckDetail,
//     IStockCheckSearch
// } from "../../base/customer/stockCheckService";
import { message } from "antd";
import { transPgToPagination } from "@/utils/utils";


export interface IMdBeSearchField {
    code?: string;
    name?: string;
    corporation?: string;
    phone?: string;
    address?: string;
    bank?: string;
    bankAccount?: string;
}

export const useStockCheckModel = createModel(function () {
    const initSearchParam: IStockCheckSearch = {};
    const initDataSource: IStockCheckDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IStockCheckSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IStockCheckDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //列表数据源分页参数
    const [selectedRow, setSelectedRow] = useState<IStockCheckFields>({});

    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [drawerVisible, setDrawerVisible] = useState(false);
    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.stocktakingCode === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IStockCheckFields)
    }, [selectedRowKeys])

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdBeSearchField) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: IStockCheckSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current)  ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await stockCheckService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    const getSelectedRowData = () => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        return filters && filters.length > 0 ? filters[0] : null;
    };
    const invalidateData = async (obj: object) => {
        let { retData } = await stockCheckService.invalidate(obj)
        if (retData) {
            message.success("作废成功");
            loadData();
        }
    }
    //列表导出
    const listExport = async () => {
        debugger
        let result = await stockCheckService.export({ ...searchParam, pageSize: 999999, pageNum: 1 });
        convertRes2Blob(result)
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        selectedRow,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        getSelectedRowData,
        setSelectedRow,
        invalidateData,
        listExport
    }
});